import React from 'react';
import { StyledButton } from './style'

const Button = ({ title, children, ...props }) => {
  props.backgroundColor=(children === 'Aguarde...') ? 'gray' : '#40bbca' 
  return (
    <StyledButton {...props}>
      { children }    
    </StyledButton>
  )
}

export default Button
